module.exports = __webpack_public_path__ + "media/images/lp_v6_img01-dec0d59e8b015714356afa17e5217a01.webp";